import React from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import toast from 'react-hot-toast';
import { routes } from '../../routes';
import { KnowledgeSubDomainFormValidation } from './KnowledgeSubDomainFormValidation';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import SelectComponent from '../../components/inputs/Select/SelectComponent';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { useGetKnowledgeDomainsQuery } from '../../hooks/useGetKnowledgeDomainsQuery';
import { createKnowledgeSubDomain } from '../../services/school/knowledgedomains/knowledgeSubDomain';
import { KnowledgeSubDomainType } from '../../types/KnowledgeDomain';

export const CreateKnowledgeSubDomain = () => {
    const navigate = useNavigate();
    const mutation = useMutation({ mutationFn: createKnowledgeSubDomain, mutationKey: "createKnowledgeSubDomain" });
    const { data: knowledgeDomains, isLoading: isLoadingKnowledgeDomains, isError: errorKnowledgeDomains } = useGetKnowledgeDomainsQuery({ PageNumber: 1, PageSize: 400 });

    const { control, handleSubmit, formState: { errors }, setValue } = useForm<KnowledgeSubDomainType>({
        resolver: yupResolver(KnowledgeSubDomainFormValidation),
        defaultValues: {
            description: '',
            code: '',
            idDomain: '',
            status: true,
        },
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
    });

    const onSubmit = handleSubmit(async (data) => {
        try {
            const result = await mutation.mutateAsync(data);
            if (result) {
                toast.success("Subdomínio de conhecimento criado!");
                navigate(routes.knowledgeSubDomains);
            }
        } catch (err: any) {
            toast.error(`${mutation.error ?? err?.message}`);
        }
    });

    const handleBack = () => {
        navigate(routes.knowledgeSubDomains);
    };

    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size='1'>
                <Flex direction='column' gap='4'>
                    <TextFieldComponent name="description" label="Nome" control={control} errors={errors} fieldProps={{ placeholder: 'Nome' }} required={true} />
                    <TextFieldComponent name="code" label='Código' control={control} errors={errors} fieldProps={{ placeholder: 'Código' }} required={true} />
                    <SelectComponent
                        name="idDomain"
                        label="Domínio de Conhecimento"
                        control={control}
                        errors={errors}
                        style={{ width: '100%' }}
                        options={knowledgeDomains?.items.map(domain => ({
                            value: domain.id ?? "",
                            label: domain.description ?? ""
                        }))}
                        itemsLoading={isLoadingKnowledgeDomains}
                        itemsError={errorKnowledgeDomains}
                        required={true}
                    />
                    <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
                        <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
                            <ChevronLeftIcon /> voltar
                        </Button>
                        <Button type="submit" disabled={mutation.isLoading} variant='surface'>
                            {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
                            Registar
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </form>
    );
};
